import { useEffect, useRef, useState } from "react";
import throttle from "lodash.throttle";

function useDocumentScrollThrottled(callback, enabled = true) {
  const [, setScrollPosition] = useState(0);
  const previousScrollTopRef = useRef(0);
  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    function handleDocumentScroll() {
      const { scrollTop: currentScrollTop } =
        document.documentElement || document.body;

      setScrollPosition((previousPosition) => {
        previousScrollTopRef.current = previousPosition;
        return currentScrollTop;
      });

      callbackRef.current({
        previousScrollTop: previousScrollTopRef.current,
        currentScrollTop,
      });
    }

    const handleDocumentScrollThrottled = throttle(handleDocumentScroll, 250);

    window.addEventListener("scroll", handleDocumentScrollThrottled);

    return () => {
      window.removeEventListener("scroll", handleDocumentScrollThrottled);
      handleDocumentScrollThrottled.cancel();
    };
  }, [enabled]);
}

export default useDocumentScrollThrottled;
